import { z } from 'zod';
import { idSchema } from './common';

/** A chave de API: o nome é a única coisa que quem cria decide. */
export const createApiKeySchema = z.object({
  name: z.string().trim().min(1, 'Dê um nome à chave.').max(80),
});
export type CreateApiKeyInput = z.infer<typeof createApiKeySchema>;

export const revokeApiKeySchema = z.object({
  apiKeyId: idSchema,
});
export type RevokeApiKeyInput = z.infer<typeof revokeApiKeySchema>;
